import { deleteField, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../services/firebase";
import { saveMedicationRecord } from "../shared/medicationPersistence";
import { normalizeMedicationDetail } from "../shared/childMedicationHelpers";

const normalizeLegacyMedicationEntries = (medicalProfile = {}) => {
  const detailedEntries = Array.isArray(medicalProfile.medicationDetails)
    ? medicalProfile.medicationDetails
    : [];
  const currentMedicationEntries = Array.isArray(medicalProfile.currentMedications)
    ? medicalProfile.currentMedications.map((entry) => (
        typeof entry === "string" ? { name: entry } : entry
      ))
    : [];

  const seen = new Set();
  return [...detailedEntries, ...currentMedicationEntries]
    .map((entry) => normalizeMedicationDetail(entry))
    .filter((entry) => {
      if (!entry.name) {
        return false;
      }

      const signature = [entry.name, entry.dose, entry.unit, entry.form, entry.scheduleType]
        .map((value) => String(value || "").trim().toLowerCase())
        .join("|");

      if (seen.has(signature)) {
        return false;
      }

      seen.add(signature);
      return true;
    });
};

export const migrateLegacyMedicationRecords = async ({
  childId = "",
  medicalProfile = {},
} = {}) => {
  const legacyMedicationRecords = normalizeLegacyMedicationEntries(medicalProfile);

  if (!childId || !legacyMedicationRecords.length) {
    return [];
  }

  const migratedRecords = [];
  for (const medication of legacyMedicationRecords) {
    const savedMedication = await saveMedicationRecord({
      childId,
      medication,
      status: "saved",
      createTimelineEvent: false,
    });
    migratedRecords.push(savedMedication);
  }

  await updateDoc(doc(db, "children", childId), {
    "medicalProfile.medicationDetails": deleteField(),
    "medicalProfile.currentMedications": deleteField(),
  });

  return migratedRecords;
};
